export const getRevenueTypeInfoStyles = (_, { palette = {} }) => ({
  infoContainer: {
    padding: '20px',
    border: `1px solid ${palette.neutralQuaternaryAlt}`,
  },
  infoList: {
    marginTop: '8px',
    paddingInlineStart: '20px',
  },
});

export const getRevenueTypeSelectorStyles = (_, { palette = {} }) => ({
  container: {
    marginRight: '55px',
    maxWidth: '620px',
    paddingLeft: '16px',

    '& .ms-ChoiceField': {
      borderBottom: `1px solid ${palette.neutralLight}`,
    },
  },
  choiceGroup: {
    '& .ms-ChoiceField-field': {
      padding: 0,
    },
  },
  description: {
    fontSize: '12px',
    fontWeight: 400,
    color: palette.neutralPrimary,
  },
  valueOption: {
    paddingLeft: '26px',
  },
  valueContainer: {
    display: 'flex',
    marginBottom: '6px',
    marginTop: '10px',
  },
});

export const getStyles = () => ({
  title: { display: 'flex' },
  revenueTypeContainer: {
    display: 'flex',
    alignItems: 'start',
    '@media only screen and (max-width: 650px)': {
      display: 'block',
    },
    '&.new-revenue-form': {
      '& .revenue-type-info': {
        marginTop: '36px',
      },
      '& .ms-ChoiceField:last-child': {
        borderBottom: 'none',
      },
    },
  },
});
